import React from 'react';
import { Params } from 'react-router';
import {motion} from 'framer-motion';


export const  ClaimsList = (props: {
    params: Readonly<Params<
        'page'
    >>
}) =>{

    const page = Number(props!.params!.page!);


    React.useEffect(() => {
        window.scrollTo(0, 0);
        const hash = window.location.hash;

        if (hash) {
          
            const id = hash.replace("#", "");
    
            const element = document.getElementById(id);
            console.log('element ', element)
            
            if (element) {
                setTimeout(() => {
                    window.scrollTo({
                        behavior: "smooth",
                        top: element.offsetTop - 100,
                        left: 0
                    });
                }, 1000);

            }
            
        }
    }, [props]);



    const claimsListDataPage = claimsListData[page - 1];


    return (
        <div data-test="claims-list-container-paginate-list">


            {claimsListDataPage.map((dataD, index) => {
                const data = dataD as {
                    provider: string;
                    date: string;
                    patient: string;
                    billed: string;
                    planPaid: string;
                    total: string;
                    status: string;
                    details?: any;
                    id?: string;
                };

                const randomInstance = Math.random() * 72;
                const randomInstance2 = Math.random() * 148;
                const calculateNextXYBounce = (x: number, y: number) => {
                        if(x > 0 && y > 0){
                            return [x - randomInstance, y - randomInstance2]
                        }
                        if(x < 0 && y < 0){
                            return [x - randomInstance, y - randomInstance2]
                        }
                        if(x > 0 && y < 0){
                            return [x - randomInstance, y + randomInstance2]
                        }
                        if(x < 0 && y > 0){
                            return [x + randomInstance, y - randomInstance2]
                        }
                        if(x === 0 && y === 0){
                            return [x + randomInstance /2 , y + randomInstance2 /2]
                        }

                        return [Math.random() * 72, Math.random() * 148]
                    }
                


                return (
                    <article
                        id={
                            data.id
                        }
                        key={index}
                        tabIndex={index} aria-labelledby={data.provider} data-test="claims-list-card-article">
                        <div data-text="claims-list-card" className="claims-list-card__card cont_-fTUNmzJEk8hzLLW9Reow">
                            <div className="claims-list-card__card-content-wrapper">
                                <div className="claims-list-card__card-header" data-test="claims-list-card-header">
                                    <svg className="svg cont_-wwx2NYr81U9_IJm7yiKR cont_-e6TXteWBj4Og8INecdNQ claims-list-card__card-icon" data-test="claims-card-icon" aria-label="medical" role="img" aria-hidden="true">
                                        <title data-test="claims-card-icon-title">medical</title>
                                        <use xlinkHref="#anatomy-stethoscope"></use>
                                    </svg>

                                    <div className="claims-list-card__card-info">
                                        {
                                            data.status === "Denied" && (

                                                <div className="cont_-iuZqIefdAd34RjD667tH push-bottom claims-list-card__status-badge cont_-w04YyaHKDqIYOyjtqDMH" data-test="claims-card-status">
                                                    <div className="cont_-eguK7HB0LR74TdMPpg24"><div className="cont_-weYlCTaB7j6x9rkMZoac" />
                                                        <div className="cont_-cdiG3ytzoWd2oXglsgqs" data-test="status-badge-text">{data.status}</div>
                                                    </div>
                                                </div>

                                            )
                                        }
                                        <h2 className="cont_-SFHQaE2KJVgFh593fnTV soft-bottom claims-list-card__card-provider" data-test="claims-card-provider">
                                            {data.provider}
                                        </h2>

                                        <time className="cont_-Wgmvua1EJ6pswU_ayqR1" data-test="claims-card-date">{data.date}</time>

                                        <p className="cont_-Wgmvua1EJ6pswU_ayqR1 claims-list-card__card-member" data-test="claims-card-patient-name">
                                            {data.patient}</p>

                                    </div>
                                </div>
                                <div className="claims-list-card__card-cost">
                                    <ul className="claims-list-card__card-list">
                                        <li>
                                            <p className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label" data-test="claims-card-billed-label">Billed</p>
                                            <div className="cont_-xzf4zIOjrXt5rU5Pdx0v" data-test="claims-card-provider-billed" >
                                                {data.billed
                                                }</div>
                                        </li>
                                        <li>
                                            <p className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label" data-test="claims-card-plan-paid-label">Plan Paid</p>

                                            <div className="cont_-xzf4zIOjrXt5rU5Pdx0v" data-test="claims-card-provider-billed">{data.planPaid}</div>
                                        </li>
                                        <li>
                                            <p className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label" data-test="claims-card-total-label">Total</p>
                                            <div className="cont_-xzf4zIOjrXt5rU5Pdx0v" data-test="claims-card-plan-paid">{data.total}</div>
                                        </li>
                                    </ul>

                                </div>
                            </div>
                            {
                                data.details && (
                                    <div className="claims-list-card__card-actions">
                                        <a
                                            className="claims-list-card__card-button cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
                                            data-test="view-claim-details-button"
                                            data-name="View Details"
                                            href={data.details.href}
                                            aria-label={
                                                data.details.ariaLabel
                                            }
                                        >
                                            View Details
                                            <motion.svg
                                                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                                                data-test="view-claim-details-button-svg"
                                                aria-label="arrow right"
                                                role="img"
                                                aria-hidden="true"
                                                initial={{
                                                    x: 100,
                                                    scale: 20,
                                                    opacity: 0.5
                                                }}

                                                // whileInView={{
                                                //     opacity: 1,
                                                //     scale: [0, 2.6, 30, 0.8, 1],
                                                //     transition: {
                                                //         delay: 0.3,
                                                //         duration: 0.8,
                                                //         ease: "easeInOut"
                                                //     },

                                                //     rotate: [0, 360],
                                                // }}

                                                exit={{
                                                    opacity: 0.2,
                                               
                                                    transition: {
                                                        duration: 0.2
                                                    }
                                                }}

                                         

                                                animate={{
                                                    opacity: 1,
                                                    
                                                    scale: [1,0.8, 20, 2.6, 0],
                                                    x:[0, -800],
                                                    y:[0, 0, -100],
                                                    rotate: [-30, -90,  -180, -270,-30, -30, 0],
                                                    transition: {
                                                        delay: 0.3,
                                                        duration: 1.2,
                                                        type:'sprint',
                                                        stiffness: 100,
                                                        damping: 10,
                                                        mass:5,
                                                        ease: "easeInOut",
                                                        repeat: Infinity,

                                                    }
                                                }}
                                                
                                            
                                            >
                                                <title data-test="view-claim-details-button-svg-title">arrow right</title>
                                                <use xlinkHref="#anatomy-arrow-right" />
                                            </motion.svg>
                                        </a>
                                    </div>

                                )
                            }
                        </div>
                    </article>
                )

            })}



        </div>
    )



}
export const claimsListData = [


    [
        {
            "status": "Denied",
            "provider": "Rebecca Maxwell",
            "date": "Visited on Oct 4, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$1,090.00",
            "planPaid": "$0.00",
            "total": "$1,090.00"
        },
        {
            "status": "Denied",
            "provider": "Rebecca Maxwell",
            "date": "Visited on Oct 3, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$1,090.00",
            "planPaid": "$0.00",
            "total": "$1,090.00"
        },
        {
            "status": "Denied",
            "provider": "Rebecca Maxwell",
            "date": "Visited on Sep 30, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$1,315.00",
            "planPaid": "$0.00",
            "total": "$1,315.00"
        },
        {
            "status": "Denied",
            "provider": "Rebecca Maxwell",
            "date": "Visited on Sep 30, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$1,315.00",
            "planPaid": "$0.00",
            "total": "$0.00"
        },
        {
            "status": "Denied",
            "provider": "Rebecca Maxwell",
            "date": "Visited on Sep 29, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$1,090.00",
            "planPaid": "$0.00",
            "total": "$1,090.00"
        },
        {
            "status": "Denied",
            "provider": "Rebecca Maxwell",
            "date": "Visited on Sep 28, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$1,090.00",
            "planPaid": "$0.00",
            "total": "$1,090.00"
        },
        {
            "status": "Denied",
            "provider": "Rebecca Maxwell",
            "date": "Visited on Sep 27, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$1,090.00",
            "planPaid": "$0.00",
            "total": "$1,090.00"
        },
        {
            "status": "Denied",
            "provider": "Rebecca Maxwell",
            "date": "Visited on Sep 26, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$1,090.00",
            "planPaid": "$0.00",
            "total": "$1,090.00"
        },
        {
            "status": "Denied",
            "provider": "Rebecca Maxwell",
            "date": "Visited on Sep 23, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$1,090.00",
            "planPaid": "$0.00",
            "total": "$1,090.00"
        },
        {
            "status": "Denied",
            "provider": "Rebecca Maxwell",
            "date": "Visited on Sep 22, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$1,090.00",
            "planPaid": "$0.00",
            "total": "$1,090.00"
        },
        {
            "status": "Denied",
            "provider": "Rebecca Maxwell",
            "date": "Visited on Sep 21, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$1,090.00",
            "planPaid": "$0.00",
            "total": "$1,090.00"
        },
        {
            "status": "Denied",
            "provider": "Rebecca Maxwell",
            "date": "Visited on Sep 20, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$1,090.00",
            "planPaid": "$0.00",
            "total": "$1,090.00"
        },
        {
            "status": "Denied",
            "provider": "Rebecca Maxwell",
            "date": "Visited on Sep 19, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$1,090.00",
            "planPaid": "$0.00",
            "total": "$1,090.00"
        },
        {
            "status": "Denied",
            "provider": "Rebecca Maxwell",
            "date": "Visited on Sep 15, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$1,090.00",
            "planPaid": "$0.00",
            "total": "$1,090.00"
        },
        {
            "status": "Denied",
            "provider": "Rebecca Maxwell",
            "date": "Visited on Sep 14, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$225.00",
            "planPaid": "$0.00",
            "total": "$0.00"
        },
        {
            "status": "Denied",
            "provider": "Rebecca Maxwell",
            "date": "Visited on Sep 14, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$1,630.00",
            "planPaid": "$0.00",
            "total": "$1,630.00"
        },
        {
            "status": "Denied",
            "provider": "Rebecca Maxwell",
            "date": "Visited on Sep 13, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$1,090.00",
            "planPaid": "$0.00",
            "total": "$1,090.00"
        },
        {
            "status": "Denied",
            "provider": "Rebecca Maxwell",
            "date": "Visited on Sep 12, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$1,090.00",
            "planPaid": "$0.00",
            "total": "$1,090.00"
        },
        {
            "status": "Denied",
            "provider": "Rebecca Maxwell",
            "date": "Visited on Sep 9, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$1,090.00",
            "planPaid": "$0.00",
            "total": "$1,090.00"
        },
        {
            "status": "Denied",
            "provider": "Rebecca Maxwell",
            "date": "Visited on Sep 8, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$1,090.00",
            "planPaid": "$0.00",
            "total": "$1,090.00"
        }
    ],
    [
        {
            "status": "Denied",
            "provider": "Scott Lisse",
            "date": "Visited on Sep 8, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$292.09",
            "planPaid": "$0.00",
            "total": "$292.05"
        },
        {
            "status": "Denied",
            "provider": "Rebecca Maxwell",
            "date": "Visited on Sep 7, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$1,090.00",
            "planPaid": "$0.00",
            "total": "$1,090.00"
        },
        {
            "status": "Denied",
            "provider": "Shelly Thomas",
            "date": "Visited on Sep 6, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$448.32",
            "planPaid": "$0.00",
            "total": "$448.32"
        },
        {
            "status": "Denied",
            "provider": "Rebecca Maxwell",
            "date": "Visited on Sep 6, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$1,090.00",
            "planPaid": "$0.00",
            "total": "$1,090.00"
        },
        {
            "status": "Denied",
            "provider": "Rebecca Maxwell",
            "date": "Visited on Sep 2, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$1,090.00",
            "planPaid": "$0.00",
            "total": "$1,090.00"
        },
        {
            "id": 'sep-1-2022-rebecca-maxwell-visit',
            "status": "Denied",
            "provider": "Rebecca Maxwell",
            "date": "Visited on Sep 1, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$1,090.00",
            "planPaid": "$0.00",
            "total": "$1,090.00",
            "details": {
                'aria-label': 'View details of visit to Rebecca Maxwell on Aug 31, 2022',
                href: "/claims/manage/sep-1-2022-rebecca-maxwell-visit"
            }
        },
        {
            "status": "Approved",
            "provider": "Rebecca Maxwell",
            "date": "Visited on Aug 31, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$1,925.00",
            "planPaid": "$267.15",
            "total": "$29.68"
        },
        {
            "status": "Approved",
            "provider": "Scott Lisse",
            "date": "Visited on Aug 17, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$206.07",
            "planPaid": "$95.17",
            "total": "$10.57"
        },
        {
            "status": "Approved",
            "provider": "Scott Lisse",
            "date": "Visited on Aug 9, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$292.09",
            "planPaid": "$134.26",
            "total": "$14.92"
        },
        {
            "status": "Approved",
            "provider": "Scott Lisse",
            "date": "Visited on Jul 14, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$304.09",
            "planPaid": "$135.65",
            "total": "$15.07"
        },
        {
            "status": "Approved",
            "provider": "Scott Lisse",
            "date": "Visited on Jul 14, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$304.09",
            "planPaid": "$5.02",
            "total": "$0.56"
        },
        {
            "status": "Approved",
            "provider": "Knoelle Park",
            "date": "Visited on Jul 13, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$264.55",
            "planPaid": "$172.52",
            "total": "$19.17"
        },
        {
            "status": "Approved",
            "provider": "Shelly Thomas",
            "date": "Visited on Jul 7, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$448.32",
            "planPaid": "$201.74",
            "total": "$22.42"
        },
        {
            "status": "Approved",
            "provider": "Knoelle Park",
            "date": "Visited on Jun 28, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$427.43",
            "planPaid": "$276.27",
            "total": "$30.70"
        },
        {
            "status": "Approved",
            "provider": "Scott Lisse",
            "date": "Visited on Jun 20, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$292.06",
            "planPaid": "$135.65",
            "total": "$15.07"
        },
        {
            "status": "Denied",
            "provider": "James Kingsley",
            "date": "Visited on Jun 17, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$406.38",
            "planPaid": "$0.00",
            "total": "$0.00"
        },
        {
            "status": "Approved",
            "provider": "James Kingsley",
            "date": "Visited on Jun 17, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$406.38",
            "planPaid": "$85.58",
            "total": "$9.51"
        },
        {
            "status": "Approved",
            "provider": "Shelly Thomas",
            "date": "Visited on May 31, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$448.32",
            "planPaid": "$201.74",
            "total": "$22.42"
        },
        {
            "status": "Approved",
            "provider": "James Kingsley",
            "date": "Visited on May 24, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$286.53",
            "planPaid": "$60.30",
            "total": "$6.70"
        },
        {
            "status": "Approved",
            "provider": "Rebecca Maxwell",
            "date": "Visited on May 13, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$250.00",
            "planPaid": "$155.65",
            "total": "$17.29"
        }
    ],
    [
        {
            "status": "Approved",
            "provider": "Shelly Thomas",
            "date": "Visited on May 10, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$303.66",
            "planPaid": "$136.65",
            "total": "$15.18"
        },
        {
            "status": "Approved",
            "provider": "James Kingsley",
            "date": "Visited on Apr 27, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$406.38",
            "planPaid": "$85.58",
            "total": "$9.51"
        },
        {
            "status": "Approved",
            "provider": "Quest Diagnostics",
            "date": "Visited on Apr 26, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$446.05",
            "planPaid": "$156.05",
            "total": "$15.41"
        },
        {
            "status": "Approved",
            "provider": "Vy Nguyen",
            "date": "Visited on Apr 26, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$175.00",
            "planPaid": "$104.97",
            "total": "$11.67"
        },
        {
            "status": "Approved",
            "provider": "Mohamed Ahmed",
            "date": "Visited on Apr 22, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$1,000.00",
            "planPaid": "$783.00",
            "total": "$87.00"
        },
        {
            "status": "Denied",
            "provider": "Mohamed Ahmed",
            "date": "Visited on Apr 15, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$210.00",
            "planPaid": "$0.00",
            "total": "$0.00"
        },
        {
            "status": "Denied",
            "provider": "The Kingsley Clinic",
            "date": "Visited on Apr 15, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$372.86",
            "planPaid": "$0.00",
            "total": "$0.00"
        },
        {
            "status": "Denied",
            "provider": "The Kingsley Clinic",
            "date": "Visited on Apr 15, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$372.86",
            "planPaid": "$0.00",
            "total": "$0.00"
        },
        {
            "status": "Approved",
            "provider": "Mohamed Ahmed",
            "date": "Visited on Apr 15, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$210.00",
            "planPaid": "$153.72",
            "total": "$17.71"
        },
        {
            "status": "Approved",
            "provider": "Mohamed Ahmed",
            "date": "Visited on Apr 14, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$75.00",
            "planPaid": "$49.69",
            "total": "$5.52"
        },
        {
            "status": "Approved",
            "provider": "The Kingsley Clinic of New Mexico LLC",
            "date": "Visited on Apr 13, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$406.38",
            "planPaid": "$0.00",
            "total": "$116.02"
        },
        {
            "status": "Approved",
            "provider": "Sobia Moghis",
            "date": "Visited on Apr 7, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$267.00",
            "planPaid": "$165.66",
            "total": "$9.64"
        },
        {
            "status": "Approved",
            "provider": "Rachel Gratz",
            "date": "Visited on Apr 6, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$175.22",
            "planPaid": "$0.00",
            "total": "$41.36"
        },
        {
            "status": "Approved",
            "provider": "The Kingsley Clinic",
            "date": "Visited on Apr 5, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$286.53",
            "planPaid": "$0.00",
            "total": "$67.00"
        },
        {
            "status": "Approved",
            "provider": "The Kingsley Clinic",
            "date": "Visited on Mar 28, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$333.27",
            "planPaid": "$95.09",
            "total": "$0.00"
        },
        {
            "status": "Approved",
            "provider": "Rachel Gratz",
            "date": "Visited on Feb 25, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$406.38",
            "planPaid": "$95.09",
            "total": "$0.00"
        },
        {
            "status": "Approved",
            "provider": "The Kingsley Clinic",
            "date": "Visited on Jan 31, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$406.38",
            "planPaid": "$95.09",
            "total": "$0.00"
        },
        {
            "status": "Approved",
            "provider": "The Kingsley Clinic",
            "date": "Visited on Jan 10, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$406.38",
            "planPaid": "$91.10",
            "total": "$0.00"
        },
        {
            "status": "Approved",
            "provider": "The Kingsley Clinic",
            "date": "Visited on Jan 6, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$333.27",
            "planPaid": "$91.10",
            "total": "$0.00"
        },
        {
            "status": "Approved",
            "provider": "Sobia Moghis",
            "date": "Visited on Jan 5, 2022",
            "patient": "For Ziping (Self)",
            "billed": "$289.00",
            "planPaid": "$229.12",
            "total": "$0.00"
        }
    ],
    [
        {
            "status": "Approved",
            "provider": "James Kingsley",
            "date": "Visited on Dec 22, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$333.27",
            "planPaid": "$91.10",
            "total": "$0.00"
        },
        {
            "status": "Approved",
            "provider": "Mohamed Ahmed",
            "date": "Visited on Dec 14, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$500.00",
            "planPaid": "$435.00",
            "total": "$0.00"
        },
        {
            "status": "Approved",
            "provider": "The Kingsley Clinic",
            "date": "Visited on Dec 14, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$333.27",
            "planPaid": "$91.10",
            "total": "$0.00"
        },
        {
            "status": "Approved",
            "provider": "Mohamed Ahmed",
            "date": "Visited on Nov 30, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$2,000.00",
            "planPaid": "$1,740.00",
            "total": "$0.00"
        },
        {
            "status": "Approved",
            "provider": "The Kingsley Clinic",
            "date": "Visited on Nov 23, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$333.27",
            "planPaid": "$91.10",
            "total": "$0.00"
        },
        {
            "status": "Approved",
            "provider": "Mohamed Ahmed",
            "date": "Visited on Nov 23, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$500.00",
            "planPaid": "$435.00",
            "total": "$0.00"
        },
        {
            "status": "Approved",
            "provider": "The Kingsley Clinic",
            "date": "Visited on Nov 17, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$333.27",
            "planPaid": "$91.10",
            "total": "$0.00"
        },
        {
            "status": "Approved",
            "provider": "Mohamed Ahmed",
            "date": "Visited on Nov 16, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$1,000.00",
            "planPaid": "$870.00",
            "total": "$0.00"
        },
        {
            "status": "Approved",
            "provider": "Mohamed Ahmed",
            "date": "Visited on Nov 4, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$1,500.00",
            "planPaid": "$1,305.00",
            "total": "$0.00"
        },
        {
            "status": "Approved",
            "provider": "The Kingsley Clinic",
            "date": "Visited on Oct 29, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$333.27",
            "planPaid": "$81.99",
            "total": "$9.11"
        },
        {
            "status": "Approved",
            "provider": "Mohamed Ahmed",
            "date": "Visited on Oct 19, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$3,000.00",
            "planPaid": "$2,363.02",
            "total": "$246.98"
        },
        {
            "status": "Approved",
            "provider": "The Kingsley Clinic",
            "date": "Visited on Oct 18, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$333.27",
            "planPaid": "$81.99",
            "total": "$9.11"
        },
        {
            "status": "Approved",
            "provider": "James Kingsley",
            "date": "Visited on Oct 6, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$333.27",
            "planPaid": "$81.99",
            "total": "$9.11"
        },
        {
            "status": "Approved",
            "provider": "Mohamed Ahmed",
            "date": "Visited on Oct 5, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$2,000.00",
            "planPaid": "$1,566.00",
            "total": "$174.00"
        },
        {
            "status": "Approved",
            "provider": "LabCorp",
            "date": "Visited on Sep 30, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$449.70",
            "planPaid": "$75.88",
            "total": "$8.43"
        },
        {
            "status": "Approved",
            "provider": "Mohamed Ahmed",
            "date": "Visited on Sep 28, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$1,500.00",
            "planPaid": "$1,174.50",
            "total": "$130.50"
        },
        {
            "status": "Approved",
            "provider": "Mohamed Ahmed",
            "date": "Visited on Sep 22, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$1,100.00",
            "planPaid": "$783.00",
            "total": "$87.00"
        },
        {
            "status": "Approved",
            "provider": "James Kingsley",
            "date": "Visited on Sep 22, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$333.27",
            "planPaid": "$81.99",
            "total": "$9.11"
        },
        {
            "status": "Approved",
            "provider": "Mohamed Ahmed",
            "date": "Visited on Sep 15, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$210.00",
            "planPaid": "$150.53",
            "total": "$16.73"
        },
        {
            "status": "Approved",
            "provider": "Scott Lisse",
            "date": "Visited on Sep 13, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$269.04",
            "planPaid": "$79.02",
            "total": "$8.78"
        }
    ], [
        {
            "status": "Approved",
            "provider": "Mohamed Ahmed",
            "date": "Visited on Sep 4, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$290.00",
            "planPaid": "$242.17",
            "total": "$26.91"
        },
        {
            "status": "Approved",
            "provider": "Scott Lisse",
            "date": "Visited on Aug 26, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$269.05",
            "planPaid": "$79.02",
            "total": "$8.78"
        },
        {
            "status": "Approved",
            "provider": "Shamima Khan",
            "date": "Visited on Aug 25, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$250.00",
            "planPaid": "$100.00",
            "total": "$11.11"
        },
        {
            "status": "Approved",
            "provider": "James Kingsley",
            "date": "Visited on Aug 25, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$333.27",
            "planPaid": "$81.99",
            "total": "$9.11"
        },
        {
            "status": "Approved",
            "provider": "Scott Lisse",
            "date": "Visited on Aug 9, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$269.02",
            "planPaid": "$79.02",
            "total": "$8.78"
        },
        {
            "status": "Approved",
            "provider": "Abiola Oyemade",
            "date": "Visited on Jul 28, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$451.00",
            "planPaid": "$136.99",
            "total": "$15.22"
        },
        {
            "status": "Approved",
            "provider": "Selma Raheem",
            "date": "Visited on Jun 24, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$175.00",
            "planPaid": "$107.74",
            "total": "$11.97"
        },
        {
            "status": "Approved",
            "provider": "Selma Raheem",
            "date": "Visited on Jun 9, 2021",
            "patient": "For Ziping (Self)",
            "billed": "$175.00",
            "planPaid": "$107.74",
            "total": "$11.97"
        }
    ]
]

export const claimsList: ((props: {
    index: number;
    key: number;
}) => JSX.Element)[] = [

        (props: { index: number }) =>
            <article
                tabIndex={props.index}
                key={props.index}
                aria-labelledby="d3efc801-2d60-4ddf-9b2a-2ad1c02285f6"
                data-test="claims-list-card-article"
            >
                <div
                    data-test="claims-list-card"
                    className="claims-list-card__card cont_-fTUNmzJEk8hzLLW9Reow"
                >
                    <div className="claims-list-card__card-content-wrapper">
                        <div
                            className="claims-list-card__card-header"
                            data-test="claims-list-card-header"
                        >
                            <svg
                                className="svg cont_-wwx2NYr81U9_IJm7yiKR cont_-e6TXteWBj4Og8INecdNQ claims-list-card__card-icon"
                                data-test="claims-card-icon"
                                aria-label="medical"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="claims-card-icon-title">
                                    medical
                                </title>
                                <use xlinkHref="#anatomy-stethoscope" />
                            </svg>
                            <div className="claims-list-card__card-info">
                                <div
                                    className="cont_-iuZqIefdAd34RjD667tH push-bottom claims-list-card__status-badge cont_-w04YyaHKDqIYOyjtqDMH"
                                    data-test="claims-card-status"
                                >
                                    <div className="cont_-eguK7HB0LR74TdMPpg24">
                                        <div className="cont_-weYlCTaB7j6x9rkMZoac" />
                                        <div
                                            className="cont_-cdiG3ytzoWd2oXglsgqs"
                                            data-test="status-badge-text"
                                        >
                                            Denied
                                        </div>
                                    </div>
                                </div>
                                <h2
                                    className="cont_-SFHQaE2KJVgFh593fnTV soft-bottom claims-list-card__card-provider"
                                    data-test="claims-card-provider"
                                    id="d3efc801-2d60-4ddf-9b2a-2ad1c02285f6"
                                >
                                    Scott Lisse
                                </h2>
                                <time
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1"
                                    data-test="claims-card-date"
                                >
                                    Visited on Sep 8, 2022
                                </time>
                                <p
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1 claims-list-card__card-member"
                                    data-test="claims-card-patient-name"
                                >
                                    For Ziping (Self)
                                </p>
                            </div>
                        </div>
                        <div className="claims-list-card__card-cost">
                            <ul className="claims-list-card__card-list">
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-member-rate-label"
                                    >
                                        Amount billed
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-provider-billed"
                                    >
                                        $292.09
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-plan-paid-label"
                                    >
                                        Your plan paid
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-plan-paid"
                                    >
                                        $0.00
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-total-cost-label"
                                    >
                                        Total amount you may owe
                                    </p>
                                    <div
                                        className="cont_-HFCcfnb1BOHqQqG09HQ5"
                                        data-test="claims-card-total"
                                    >
                                        $292.05
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="claims-list-card__card-actions">
                        <a
                            className="claims-list-card__card-button cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
                            data-test="view-claim-details-button"
                            data-name="View Details"
                            href="https://health.aetna.com/manage/claims/56~SFBD8JJX+22+547+F+EW5?membershipResourceId=5~264012314%2B18%2B101%2B20220601%2B868404%2BA%2B1"
                            aria-label="View details of visit to Scott Lisse on Sep 8, 2022 for Ziping (Self)"
                        >
                            View Details
                            <svg
                                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                                data-test="view-claim-details-button-svg"
                                aria-label="arrow right"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="view-claim-details-button-svg-title">
                                    arrow right
                                </title>
                                <use xlinkHref="#anatomy-arrow-right" />
                            </svg>
                        </a>
                    </div>
                </div>
            </article>,
        (props: { index: number }) =>
            <article
                tabIndex={props.index}
                key={props.index}
                aria-labelledby="fb1f4d4b-de46-44e9-9c0c-67832d8496ac"
                data-test="claims-list-card-article"
            >
                <div
                    data-test="claims-list-card"
                    className="claims-list-card__card cont_-fTUNmzJEk8hzLLW9Reow"
                >
                    <div className="claims-list-card__card-content-wrapper">
                        <div
                            className="claims-list-card__card-header"
                            data-test="claims-list-card-header"
                        >
                            <svg
                                className="svg cont_-wwx2NYr81U9_IJm7yiKR cont_-e6TXteWBj4Og8INecdNQ claims-list-card__card-icon"
                                data-test="claims-card-icon"
                                aria-label="medical"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="claims-card-icon-title">
                                    medical
                                </title>
                                <use xlinkHref="#anatomy-stethoscope" />
                            </svg>
                            <div className="claims-list-card__card-info">
                                <div
                                    className="cont_-iuZqIefdAd34RjD667tH push-bottom claims-list-card__status-badge cont_-w04YyaHKDqIYOyjtqDMH"
                                    data-test="claims-card-status"
                                >
                                    <div className="cont_-eguK7HB0LR74TdMPpg24">
                                        <div className="cont_-weYlCTaB7j6x9rkMZoac" />
                                        <div
                                            className="cont_-cdiG3ytzoWd2oXglsgqs"
                                            data-test="status-badge-text"
                                        >
                                            Denied
                                        </div>
                                    </div>
                                </div>
                                <h2
                                    className="cont_-SFHQaE2KJVgFh593fnTV soft-bottom claims-list-card__card-provider"
                                    data-test="claims-card-provider"
                                    id="fb1f4d4b-de46-44e9-9c0c-67832d8496ac"
                                >
                                    Rebecca Maxwell
                                </h2>
                                <time
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1"
                                    data-test="claims-card-date"
                                >
                                    Visited on Sep 7, 2022
                                </time>
                                <p
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1 claims-list-card__card-member"
                                    data-test="claims-card-patient-name"
                                >
                                    For Ziping (Self)
                                </p>
                            </div>
                        </div>
                        <div className="claims-list-card__card-cost">
                            <ul className="claims-list-card__card-list">
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-member-rate-label"
                                    >
                                        Amount billed
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-provider-billed"
                                    >
                                        $1,090.00
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-plan-paid-label"
                                    >
                                        Your plan paid
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-plan-paid"
                                    >
                                        $0.00
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-total-cost-label"
                                    >
                                        Total amount you may owe
                                    </p>
                                    <div
                                        className="cont_-HFCcfnb1BOHqQqG09HQ5"
                                        data-test="claims-card-total"
                                    >
                                        $1,090.00
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="claims-list-card__card-actions">
                        <a
                            className="claims-list-card__card-button cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
                            data-test="view-claim-details-button"
                            data-name="View Details"
                            href="https://health.aetna.com/manage/claims/56~GJLKWC4B+22+411+F+EW1?membershipResourceId=5~264012314%2B18%2B101%2B20220601%2B868404%2BA%2B1"
                            aria-label="View details of visit to Rebecca Maxwell on Sep 7, 2022 for Ziping (Self)"
                        >
                            View Details
                            <svg
                                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                                data-test="view-claim-details-button-svg"
                                aria-label="arrow right"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="view-claim-details-button-svg-title">
                                    arrow right
                                </title>
                                <use xlinkHref="#anatomy-arrow-right" />
                            </svg>
                        </a>
                    </div>
                </div>
            </article>,
        (props: { index: number }) =>
            <article
                tabIndex={props.index}
                key={props.index}
                aria-labelledby="8c1bf94d-2796-4090-81a2-2e2e0ffe3072"
                data-test="claims-list-card-article"
            >
                <div
                    data-test="claims-list-card"
                    className="claims-list-card__card cont_-fTUNmzJEk8hzLLW9Reow"
                >
                    <div className="claims-list-card__card-content-wrapper">
                        <div
                            className="claims-list-card__card-header"
                            data-test="claims-list-card-header"
                        >
                            <svg
                                className="svg cont_-wwx2NYr81U9_IJm7yiKR cont_-e6TXteWBj4Og8INecdNQ claims-list-card__card-icon"
                                data-test="claims-card-icon"
                                aria-label="medical"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="claims-card-icon-title">
                                    medical
                                </title>
                                <use xlinkHref="#anatomy-stethoscope" />
                            </svg>
                            <div className="claims-list-card__card-info">
                                <div
                                    className="cont_-iuZqIefdAd34RjD667tH push-bottom claims-list-card__status-badge cont_-w04YyaHKDqIYOyjtqDMH"
                                    data-test="claims-card-status"
                                >
                                    <div className="cont_-eguK7HB0LR74TdMPpg24">
                                        <div className="cont_-weYlCTaB7j6x9rkMZoac" />
                                        <div
                                            className="cont_-cdiG3ytzoWd2oXglsgqs"
                                            data-test="status-badge-text"
                                        >
                                            Denied
                                        </div>
                                    </div>
                                </div>
                                <h2
                                    className="cont_-SFHQaE2KJVgFh593fnTV soft-bottom claims-list-card__card-provider"
                                    data-test="claims-card-provider"
                                    id="8c1bf94d-2796-4090-81a2-2e2e0ffe3072"
                                >
                                    Shelly Thomas
                                </h2>
                                <time
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1"
                                    data-test="claims-card-date"
                                >
                                    Visited on Sep 6, 2022
                                </time>
                                <p
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1 claims-list-card__card-member"
                                    data-test="claims-card-patient-name"
                                >
                                    For Ziping (Self)
                                </p>
                            </div>
                        </div>
                        <div className="claims-list-card__card-cost">
                            <ul className="claims-list-card__card-list">
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-member-rate-label"
                                    >
                                        Amount billed
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-provider-billed"
                                    >
                                        $448.32
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-plan-paid-label"
                                    >
                                        Your plan paid
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-plan-paid"
                                    >
                                        $0.00
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-total-cost-label"
                                    >
                                        Total amount you may owe
                                    </p>
                                    <div
                                        className="cont_-HFCcfnb1BOHqQqG09HQ5"
                                        data-test="claims-card-total"
                                    >
                                        $448.32
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="claims-list-card__card-actions">
                        <a
                            className="claims-list-card__card-button cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
                            data-test="view-claim-details-button"
                            data-name="View Details"
                            href="https://health.aetna.com/manage/claims/56~5JLHF2JX+22+855+F+EW4?membershipResourceId=5~264012314%2B18%2B101%2B20220601%2B868404%2BA%2B1"
                            aria-label="View details of visit to Shelly Thomas on Sep 6, 2022 for Ziping (Self)"
                        >
                            View Details
                            <svg
                                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                                data-test="view-claim-details-button-svg"
                                aria-label="arrow right"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="view-claim-details-button-svg-title">
                                    arrow right
                                </title>
                                <use xlinkHref="#anatomy-arrow-right" />
                            </svg>
                        </a>
                    </div>
                </div>
            </article>,
        (props: { index: number }) =>
            <article
                tabIndex={props.index}
                key={props.index}
                aria-labelledby="056b84c2-9248-4270-9273-bba1066d13d2"
                data-test="claims-list-card-article"
            >
                <div
                    data-test="claims-list-card"
                    className="claims-list-card__card cont_-fTUNmzJEk8hzLLW9Reow"
                >
                    <div className="claims-list-card__card-content-wrapper">
                        <div
                            className="claims-list-card__card-header"
                            data-test="claims-list-card-header"
                        >
                            <svg
                                className="svg cont_-wwx2NYr81U9_IJm7yiKR cont_-e6TXteWBj4Og8INecdNQ claims-list-card__card-icon"
                                data-test="claims-card-icon"
                                aria-label="medical"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="claims-card-icon-title">
                                    medical
                                </title>
                                <use xlinkHref="#anatomy-stethoscope" />
                            </svg>
                            <div className="claims-list-card__card-info">
                                <div
                                    className="cont_-iuZqIefdAd34RjD667tH push-bottom claims-list-card__status-badge cont_-w04YyaHKDqIYOyjtqDMH"
                                    data-test="claims-card-status"
                                >
                                    <div className="cont_-eguK7HB0LR74TdMPpg24">
                                        <div className="cont_-weYlCTaB7j6x9rkMZoac" />
                                        <div
                                            className="cont_-cdiG3ytzoWd2oXglsgqs"
                                            data-test="status-badge-text"
                                        >
                                            Denied
                                        </div>
                                    </div>
                                </div>
                                <h2
                                    className="cont_-SFHQaE2KJVgFh593fnTV soft-bottom claims-list-card__card-provider"
                                    data-test="claims-card-provider"
                                    id="056b84c2-9248-4270-9273-bba1066d13d2"
                                >
                                    Rebecca Maxwell
                                </h2>
                                <time
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1"
                                    data-test="claims-card-date"
                                >
                                    Visited on Sep 6, 2022
                                </time>
                                <p
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1 claims-list-card__card-member"
                                    data-test="claims-card-patient-name"
                                >
                                    For Ziping (Self)
                                </p>
                            </div>
                        </div>
                        <div className="claims-list-card__card-cost">
                            <ul className="claims-list-card__card-list">
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-member-rate-label"
                                    >
                                        Amount billed
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-provider-billed"
                                    >
                                        $1,090.00
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-plan-paid-label"
                                    >
                                        Your plan paid
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-plan-paid"
                                    >
                                        $0.00
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-total-cost-label"
                                    >
                                        Total amount you may owe
                                    </p>
                                    <div
                                        className="cont_-HFCcfnb1BOHqQqG09HQ5"
                                        data-test="claims-card-total"
                                    >
                                        $1,090.00
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="claims-list-card__card-actions">
                        <a
                            className="claims-list-card__card-button cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
                            data-test="view-claim-details-button"
                            data-name="View Details"
                            href="https://health.aetna.com/manage/claims/56~5JLG87HW+22+2385+F+EW4?membershipResourceId=5~264012314%2B18%2B101%2B20220601%2B868404%2BA%2B1"
                            aria-label="View details of visit to Rebecca Maxwell on Sep 6, 2022 for Ziping (Self)"
                        >
                            View Details
                            <svg
                                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                                data-test="view-claim-details-button-svg"
                                aria-label="arrow right"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="view-claim-details-button-svg-title">
                                    arrow right
                                </title>
                                <use xlinkHref="#anatomy-arrow-right" />
                            </svg>
                        </a>
                    </div>
                </div>
            </article>,
        (props: { index: number }) =>
            <article
                tabIndex={props.index}
                key={props.index}
                aria-labelledby="1b3f3917-0082-42af-93ef-be6b342bda36"
                data-test="claims-list-card-article"
            >
                <div
                    data-test="claims-list-card"
                    className="claims-list-card__card cont_-fTUNmzJEk8hzLLW9Reow"
                >
                    <div className="claims-list-card__card-content-wrapper">
                        <div
                            className="claims-list-card__card-header"
                            data-test="claims-list-card-header"
                        >
                            <svg
                                className="svg cont_-wwx2NYr81U9_IJm7yiKR cont_-e6TXteWBj4Og8INecdNQ claims-list-card__card-icon"
                                data-test="claims-card-icon"
                                aria-label="medical"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="claims-card-icon-title">
                                    medical
                                </title>
                                <use xlinkHref="#anatomy-stethoscope" />
                            </svg>
                            <div className="claims-list-card__card-info">
                                <div
                                    className="cont_-iuZqIefdAd34RjD667tH push-bottom claims-list-card__status-badge cont_-w04YyaHKDqIYOyjtqDMH"
                                    data-test="claims-card-status"
                                >
                                    <div className="cont_-eguK7HB0LR74TdMPpg24">
                                        <div className="cont_-weYlCTaB7j6x9rkMZoac" />
                                        <div
                                            className="cont_-cdiG3ytzoWd2oXglsgqs"
                                            data-test="status-badge-text"
                                        >
                                            Denied
                                        </div>
                                    </div>
                                </div>
                                <h2
                                    className="cont_-SFHQaE2KJVgFh593fnTV soft-bottom claims-list-card__card-provider"
                                    data-test="claims-card-provider"
                                    id="1b3f3917-0082-42af-93ef-be6b342bda36"
                                >
                                    Rebecca Maxwell
                                </h2>
                                <time
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1"
                                    data-test="claims-card-date"
                                >
                                    Visited on Sep 2, 2022
                                </time>
                                <p
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1 claims-list-card__card-member"
                                    data-test="claims-card-patient-name"
                                >
                                    For Ziping (Self)
                                </p>
                            </div>
                        </div>
                        <div className="claims-list-card__card-cost">
                            <ul className="claims-list-card__card-list">
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-member-rate-label"
                                    >
                                        Amount billed
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-provider-billed"
                                    >
                                        $1,090.00
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-plan-paid-label"
                                    >
                                        Your plan paid
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-plan-paid"
                                    >
                                        $0.00
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-total-cost-label"
                                    >
                                        Total amount you may owe
                                    </p>
                                    <div
                                        className="cont_-HFCcfnb1BOHqQqG09HQ5"
                                        data-test="claims-card-total"
                                    >
                                        $1,090.00
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="claims-list-card__card-actions">
                        <a
                            className="claims-list-card__card-button cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
                            data-test="view-claim-details-button"
                            data-name="View Details"
                            href="https://health.aetna.com/manage/claims/56~RWYDPSWG+22+413+F+EW2?membershipResourceId=5~264012314%2B18%2B101%2B20220601%2B868404%2BA%2B1"
                            aria-label="View details of visit to Rebecca Maxwell on Sep 2, 2022 for Ziping (Self)"
                        >
                            View Details
                            <svg
                                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                                data-test="view-claim-details-button-svg"
                                aria-label="arrow right"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="view-claim-details-button-svg-title">
                                    arrow right
                                </title>
                                <use xlinkHref="#anatomy-arrow-right" />
                            </svg>
                        </a>
                    </div>
                </div>
            </article>,
        (props: { index: number }) =>
            <article
                tabIndex={props.index}
                key={props.index}
                aria-labelledby="be7cbe6f-aa04-4c3e-ba95-e62c116f575f"
                data-test="claims-list-card-article"
            >
                <div
                    data-test="claims-list-card"
                    className="claims-list-card__card cont_-fTUNmzJEk8hzLLW9Reow"
                >
                    <div className="claims-list-card__card-content-wrapper">
                        <div
                            className="claims-list-card__card-header"
                            data-test="claims-list-card-header"
                        >
                            <svg
                                className="svg cont_-wwx2NYr81U9_IJm7yiKR cont_-e6TXteWBj4Og8INecdNQ claims-list-card__card-icon"
                                data-test="claims-card-icon"
                                aria-label="medical"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="claims-card-icon-title">
                                    medical
                                </title>
                                <use xlinkHref="#anatomy-stethoscope" />
                            </svg>
                            <div className="claims-list-card__card-info">
                                <div
                                    className="cont_-iuZqIefdAd34RjD667tH push-bottom claims-list-card__status-badge cont_-w04YyaHKDqIYOyjtqDMH"
                                    data-test="claims-card-status"
                                >
                                    <div className="cont_-eguK7HB0LR74TdMPpg24">
                                        <div className="cont_-weYlCTaB7j6x9rkMZoac" />
                                        <div
                                            className="cont_-cdiG3ytzoWd2oXglsgqs"
                                            data-test="status-badge-text"
                                        >
                                            Denied
                                        </div>
                                    </div>
                                </div>
                                <h2
                                    className="cont_-SFHQaE2KJVgFh593fnTV soft-bottom claims-list-card__card-provider"
                                    data-test="claims-card-provider"
                                    id="be7cbe6f-aa04-4c3e-ba95-e62c116f575f"
                                >
                                    Rebecca Maxwell
                                </h2>
                                <time
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1"
                                    data-test="claims-card-date"
                                >
                                    Visited on Sep 1, 2022
                                </time>
                                <p
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1 claims-list-card__card-member"
                                    data-test="claims-card-patient-name"
                                >
                                    For Ziping (Self)
                                </p>
                            </div>
                        </div>
                        <div className="claims-list-card__card-cost">
                            <ul className="claims-list-card__card-list">
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-member-rate-label"
                                    >
                                        Amount billed
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-provider-billed"
                                    >
                                        $1,090.00
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-plan-paid-label"
                                    >
                                        Your plan paid
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-plan-paid"
                                    >
                                        $0.00
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-total-cost-label"
                                    >
                                        Total amount you may owe
                                    </p>
                                    <div
                                        className="cont_-HFCcfnb1BOHqQqG09HQ5"
                                        data-test="claims-card-total"
                                    >
                                        $1,090.00
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="claims-list-card__card-actions">
                        <a
                            className="claims-list-card__card-button cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
                            data-test="view-claim-details-button"
                            data-name="View Details"
                            href="https://health.aetna.com/manage/claims/56~5ABJKKQL+22+495+F+EW4?membershipResourceId=5~264012314%2B18%2B101%2B20220601%2B868404%2BA%2B1"
                            aria-label="View details of visit to Rebecca Maxwell on Sep 1, 2022 for Ziping (Self)"
                        >
                            View Details
                            <svg
                                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                                data-test="view-claim-details-button-svg"
                                aria-label="arrow right"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="view-claim-details-button-svg-title">
                                    arrow right
                                </title>
                                <use xlinkHref="#anatomy-arrow-right" />
                            </svg>
                        </a>
                    </div>
                </div>
            </article>,
        (props: { index: number }) =>
            <article
                tabIndex={props.index}
                key={props.index}
                aria-labelledby="fc271045-d0e6-49d2-9335-91091c6820d5"
                data-test="claims-list-card-article"
            >
                <div
                    data-test="claims-list-card"
                    className="claims-list-card__card cont_-fTUNmzJEk8hzLLW9Reow"
                >
                    <div className="claims-list-card__card-content-wrapper">
                        <div
                            className="claims-list-card__card-header"
                            data-test="claims-list-card-header"
                        >
                            <svg
                                className="svg cont_-wwx2NYr81U9_IJm7yiKR cont_-e6TXteWBj4Og8INecdNQ claims-list-card__card-icon"
                                data-test="claims-card-icon"
                                aria-label="medical"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="claims-card-icon-title">
                                    medical
                                </title>
                                <use xlinkHref="#anatomy-stethoscope" />
                            </svg>
                            <div className="claims-list-card__card-info">
                                <h2
                                    className="cont_-SFHQaE2KJVgFh593fnTV soft-bottom claims-list-card__card-provider"
                                    data-test="claims-card-provider"
                                    id="fc271045-d0e6-49d2-9335-91091c6820d5"
                                >
                                    Rebecca Maxwell
                                </h2>
                                <time
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1"
                                    data-test="claims-card-date"
                                >
                                    Visited on Aug 31, 2022
                                </time>
                                <p
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1 claims-list-card__card-member"
                                    data-test="claims-card-patient-name"
                                >
                                    For Ziping (Self)
                                </p>
                            </div>
                        </div>
                        <div className="claims-list-card__card-cost">
                            <ul className="claims-list-card__card-list">
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-member-rate-label"
                                    >
                                        Amount billed
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-provider-billed"
                                    >
                                        $1,925.00
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-plan-paid-label"
                                    >
                                        Your plan paid
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-plan-paid"
                                    >
                                        $267.15
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-total-cost-label"
                                    >
                                        Total amount you may owe
                                    </p>
                                    <div
                                        className="cont_-HFCcfnb1BOHqQqG09HQ5"
                                        data-test="claims-card-total"
                                    >
                                        $29.68
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="claims-list-card__card-actions">
                        <a
                            className="claims-list-card__card-button cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
                            data-test="view-claim-details-button"
                            data-name="View Details"
                            href="https://health.aetna.com/manage/claims/56~GTWJ1TYJ+22+536+F+EW3?membershipResourceId=5~264012314%2B18%2B101%2B20220601%2B868404%2BA%2B1"
                            aria-label="View details of visit to Rebecca Maxwell on Aug 31, 2022 for Ziping (Self)"
                        >
                            View Details
                            <svg
                                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                                data-test="view-claim-details-button-svg"
                                aria-label="arrow right"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="view-claim-details-button-svg-title">
                                    arrow right
                                </title>
                                <use xlinkHref="#anatomy-arrow-right" />
                            </svg>
                        </a>
                    </div>
                </div>
            </article>,
        (props: { index: number }) =>
            <article
                tabIndex={props.index}
                key={props.index}
                aria-labelledby="6f0c7c34-9c50-48ad-863f-a27643d79129"
                data-test="claims-list-card-article"
            >
                <div
                    data-test="claims-list-card"
                    className="claims-list-card__card cont_-fTUNmzJEk8hzLLW9Reow"
                >
                    <div className="claims-list-card__card-content-wrapper">
                        <div
                            className="claims-list-card__card-header"
                            data-test="claims-list-card-header"
                        >
                            <svg
                                className="svg cont_-wwx2NYr81U9_IJm7yiKR cont_-e6TXteWBj4Og8INecdNQ claims-list-card__card-icon"
                                data-test="claims-card-icon"
                                aria-label="medical"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="claims-card-icon-title">
                                    medical
                                </title>
                                <use xlinkHref="#anatomy-stethoscope" />
                            </svg>
                            <div className="claims-list-card__card-info">
                                <h2
                                    className="cont_-SFHQaE2KJVgFh593fnTV soft-bottom claims-list-card__card-provider"
                                    data-test="claims-card-provider"
                                    id="6f0c7c34-9c50-48ad-863f-a27643d79129"
                                >
                                    Scott Lisse
                                </h2>
                                <time
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1"
                                    data-test="claims-card-date"
                                >
                                    Visited on Aug 17, 2022
                                </time>
                                <p
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1 claims-list-card__card-member"
                                    data-test="claims-card-patient-name"
                                >
                                    For Ziping (Self)
                                </p>
                            </div>
                        </div>
                        <div className="claims-list-card__card-cost">
                            <ul className="claims-list-card__card-list">
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-member-rate-label"
                                    >
                                        Amount billed
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-provider-billed"
                                    >
                                        $206.07
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-plan-paid-label"
                                    >
                                        Your plan paid
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-plan-paid"
                                    >
                                        $95.17
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-total-cost-label"
                                    >
                                        Total amount you may owe
                                    </p>
                                    <div
                                        className="cont_-HFCcfnb1BOHqQqG09HQ5"
                                        data-test="claims-card-total"
                                    >
                                        $10.57
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="claims-list-card__card-actions">
                        <a
                            className="claims-list-card__card-button cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
                            data-test="view-claim-details-button"
                            data-name="View Details"
                            href="https://health.aetna.com/manage/claims/56~F35LLDGB+22+3057+F+EW1?membershipResourceId=5~264012314%2B18%2B101%2B20220601%2B868404%2BA%2B1"
                            aria-label="View details of visit to Scott Lisse on Aug 17, 2022 for Ziping (Self)"
                        >
                            View Details
                            <svg
                                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                                data-test="view-claim-details-button-svg"
                                aria-label="arrow right"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="view-claim-details-button-svg-title">
                                    arrow right
                                </title>
                                <use xlinkHref="#anatomy-arrow-right" />
                            </svg>
                        </a>
                    </div>
                </div>
            </article>,
        (props: { index: number }) =>
            <article
                tabIndex={props.index}
                key={props.index}
                aria-labelledby="bd3b6bb2-63fc-4dd6-aade-eb722e10d78d"
                data-test="claims-list-card-article"
            >
                <div
                    data-test="claims-list-card"
                    className="claims-list-card__card cont_-fTUNmzJEk8hzLLW9Reow"
                >
                    <div className="claims-list-card__card-content-wrapper">
                        <div
                            className="claims-list-card__card-header"
                            data-test="claims-list-card-header"
                        >
                            <svg
                                className="svg cont_-wwx2NYr81U9_IJm7yiKR cont_-e6TXteWBj4Og8INecdNQ claims-list-card__card-icon"
                                data-test="claims-card-icon"
                                aria-label="medical"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="claims-card-icon-title">
                                    medical
                                </title>
                                <use xlinkHref="#anatomy-stethoscope" />
                            </svg>
                            <div className="claims-list-card__card-info">
                                <h2
                                    className="cont_-SFHQaE2KJVgFh593fnTV soft-bottom claims-list-card__card-provider"
                                    data-test="claims-card-provider"
                                    id="bd3b6bb2-63fc-4dd6-aade-eb722e10d78d"
                                >
                                    Scott Lisse
                                </h2>
                                <time
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1"
                                    data-test="claims-card-date"
                                >
                                    Visited on Aug 9, 2022
                                </time>
                                <p
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1 claims-list-card__card-member"
                                    data-test="claims-card-patient-name"
                                >
                                    For Ziping (Self)
                                </p>
                            </div>
                        </div>
                        <div className="claims-list-card__card-cost">
                            <ul className="claims-list-card__card-list">
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-member-rate-label"
                                    >
                                        Amount billed
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-provider-billed"
                                    >
                                        $292.09
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-plan-paid-label"
                                    >
                                        Your plan paid
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-plan-paid"
                                    >
                                        $134.26
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-total-cost-label"
                                    >
                                        Total amount you may owe
                                    </p>
                                    <div
                                        className="cont_-HFCcfnb1BOHqQqG09HQ5"
                                        data-test="claims-card-total"
                                    >
                                        $14.92
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="claims-list-card__card-actions">
                        <a
                            className="claims-list-card__card-button cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
                            data-test="view-claim-details-button"
                            data-name="View Details"
                            href="https://health.aetna.com/manage/claims/56~FPBLKS6F+22+451+F+EW1?membershipResourceId=5~264012314%2B18%2B101%2B20220601%2B868404%2BA%2B1"
                            aria-label="View details of visit to Scott Lisse on Aug 9, 2022 for Ziping (Self)"
                        >
                            View Details
                            <svg
                                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                                data-test="view-claim-details-button-svg"
                                aria-label="arrow right"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="view-claim-details-button-svg-title">
                                    arrow right
                                </title>
                                <use xlinkHref="#anatomy-arrow-right" />
                            </svg>
                        </a>
                    </div>
                </div>
            </article>,
        (props: { index: number }) =>
            <article
                tabIndex={props.index}
                key={props.index}
                aria-labelledby="e060d5c1-8d42-492f-a569-5a1b58b135fa"
                data-test="claims-list-card-article"
            >
                <div
                    data-test="claims-list-card"
                    className="claims-list-card__card cont_-fTUNmzJEk8hzLLW9Reow"
                >
                    <div className="claims-list-card__card-content-wrapper">
                        <div
                            className="claims-list-card__card-header"
                            data-test="claims-list-card-header"
                        >
                            <svg
                                className="svg cont_-wwx2NYr81U9_IJm7yiKR cont_-e6TXteWBj4Og8INecdNQ claims-list-card__card-icon"
                                data-test="claims-card-icon"
                                aria-label="medical"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="claims-card-icon-title">
                                    medical
                                </title>
                                <use xlinkHref="#anatomy-stethoscope" />
                            </svg>
                            <div className="claims-list-card__card-info">
                                <h2
                                    className="cont_-SFHQaE2KJVgFh593fnTV soft-bottom claims-list-card__card-provider"
                                    data-test="claims-card-provider"
                                    id="e060d5c1-8d42-492f-a569-5a1b58b135fa"
                                >
                                    Scott Lisse
                                </h2>
                                <time
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1"
                                    data-test="claims-card-date"
                                >
                                    Visited on Jul 14, 2022
                                </time>
                                <p
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1 claims-list-card__card-member"
                                    data-test="claims-card-patient-name"
                                >
                                    For Ziping (Self)
                                </p>
                            </div>
                        </div>
                        <div className="claims-list-card__card-cost">
                            <ul className="claims-list-card__card-list">
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-member-rate-label"
                                    >
                                        Amount billed
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-provider-billed"
                                    >
                                        $304.09
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-plan-paid-label"
                                    >
                                        Your plan paid
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-plan-paid"
                                    >
                                        $135.65
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-total-cost-label"
                                    >
                                        Total amount you may owe
                                    </p>
                                    <div
                                        className="cont_-HFCcfnb1BOHqQqG09HQ5"
                                        data-test="claims-card-total"
                                    >
                                        $15.07
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="claims-list-card__card-actions">
                        <a
                            className="claims-list-card__card-button cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
                            data-test="view-claim-details-button"
                            data-name="View Details"
                            href="https://health.aetna.com/manage/claims/56~FPBLKS0P+22+267+F+EW1?membershipResourceId=5~264012314%2B18%2B101%2B20220601%2B868404%2BA%2B1"
                            aria-label="View details of visit to Scott Lisse on Jul 14, 2022 for Ziping (Self)"
                        >
                            View Details
                            <svg
                                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                                data-test="view-claim-details-button-svg"
                                aria-label="arrow right"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="view-claim-details-button-svg-title">
                                    arrow right
                                </title>
                                <use xlinkHref="#anatomy-arrow-right" />
                            </svg>
                        </a>
                    </div>
                </div>
            </article>,
        (props: { index: number }) =>
            <article
                tabIndex={props.index}
                key={props.index}
                aria-labelledby="0fad932e-a9e3-4f49-a07d-9e7d151e61be"
                data-test="claims-list-card-article"
            >
                <div
                    data-test="claims-list-card"
                    className="claims-list-card__card cont_-fTUNmzJEk8hzLLW9Reow"
                >
                    <div className="claims-list-card__card-content-wrapper">
                        <div
                            className="claims-list-card__card-header"
                            data-test="claims-list-card-header"
                        >
                            <svg
                                className="svg cont_-wwx2NYr81U9_IJm7yiKR cont_-e6TXteWBj4Og8INecdNQ claims-list-card__card-icon"
                                data-test="claims-card-icon"
                                aria-label="medical"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="claims-card-icon-title">
                                    medical
                                </title>
                                <use xlinkHref="#anatomy-stethoscope" />
                            </svg>
                            <div className="claims-list-card__card-info">
                                <h2
                                    className="cont_-SFHQaE2KJVgFh593fnTV soft-bottom claims-list-card__card-provider"
                                    data-test="claims-card-provider"
                                    id="0fad932e-a9e3-4f49-a07d-9e7d151e61be"
                                >
                                    Scott Lisse
                                </h2>
                                <time
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1"
                                    data-test="claims-card-date"
                                >
                                    Visited on Jul 14, 2022
                                </time>
                                <p
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1 claims-list-card__card-member"
                                    data-test="claims-card-patient-name"
                                >
                                    For Ziping (Self)
                                </p>
                            </div>
                        </div>
                        <div className="claims-list-card__card-cost">
                            <ul className="claims-list-card__card-list">
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-member-rate-label"
                                    >
                                        Amount billed
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-provider-billed"
                                    >
                                        $304.09
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-plan-paid-label"
                                    >
                                        Your plan paid
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-plan-paid"
                                    >
                                        $5.02
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-total-cost-label"
                                    >
                                        Total amount you may owe
                                    </p>
                                    <div
                                        className="cont_-HFCcfnb1BOHqQqG09HQ5"
                                        data-test="claims-card-total"
                                    >
                                        $0.56
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="claims-list-card__card-actions">
                        <a
                            className="claims-list-card__card-button cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
                            data-test="view-claim-details-button"
                            data-name="View Details"
                            href="https://health.aetna.com/manage/claims/56~GTWKQLTS+22+65+F+EW1?membershipResourceId=5~264012314%2B18%2B101%2B20220601%2B868404%2BA%2B1"
                            aria-label="View details of visit to Scott Lisse on Jul 14, 2022 for Ziping (Self)"
                        >
                            View Details
                            <svg
                                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                                data-test="view-claim-details-button-svg"
                                aria-label="arrow right"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="view-claim-details-button-svg-title">
                                    arrow right
                                </title>
                                <use xlinkHref="#anatomy-arrow-right" />
                            </svg>
                        </a>
                    </div>
                </div>
            </article>,
        (props: { index: number }) =>
            <article
                tabIndex={props.index}
                key={props.index}
                aria-labelledby="19a87362-ed5c-4480-b779-ceec94f5e6aa"
                data-test="claims-list-card-article"
            >
                <div
                    data-test="claims-list-card"
                    className="claims-list-card__card cont_-fTUNmzJEk8hzLLW9Reow"
                >
                    <div className="claims-list-card__card-content-wrapper">
                        <div
                            className="claims-list-card__card-header"
                            data-test="claims-list-card-header"
                        >
                            <svg
                                className="svg cont_-wwx2NYr81U9_IJm7yiKR cont_-e6TXteWBj4Og8INecdNQ claims-list-card__card-icon"
                                data-test="claims-card-icon"
                                aria-label="medical"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="claims-card-icon-title">
                                    medical
                                </title>
                                <use xlinkHref="#anatomy-stethoscope" />
                            </svg>
                            <div className="claims-list-card__card-info">
                                <h2
                                    className="cont_-SFHQaE2KJVgFh593fnTV soft-bottom claims-list-card__card-provider"
                                    data-test="claims-card-provider"
                                    id="19a87362-ed5c-4480-b779-ceec94f5e6aa"
                                >
                                    Knoelle Park
                                </h2>
                                <time
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1"
                                    data-test="claims-card-date"
                                >
                                    Visited on Jul 13, 2022
                                </time>
                                <p
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1 claims-list-card__card-member"
                                    data-test="claims-card-patient-name"
                                >
                                    For Ziping (Self)
                                </p>
                            </div>
                        </div>
                        <div className="claims-list-card__card-cost">
                            <ul className="claims-list-card__card-list">
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-member-rate-label"
                                    >
                                        Amount billed
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-provider-billed"
                                    >
                                        $264.55
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-plan-paid-label"
                                    >
                                        Your plan paid
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-plan-paid"
                                    >
                                        $172.52
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-total-cost-label"
                                    >
                                        Total amount you may owe
                                    </p>
                                    <div
                                        className="cont_-HFCcfnb1BOHqQqG09HQ5"
                                        data-test="claims-card-total"
                                    >
                                        $19.17
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="claims-list-card__card-actions">
                        <a
                            className="claims-list-card__card-button cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
                            data-test="view-claim-details-button"
                            data-name="View Details"
                            href="https://health.aetna.com/manage/claims/56~PTWH0W3R+22+30188+F+EW2?membershipResourceId=5~264012314%2B18%2B101%2B20220601%2B868404%2BA%2B1"
                            aria-label="View details of visit to Knoelle Park on Jul 13, 2022 for Ziping (Self)"
                        >
                            View Details
                            <svg
                                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                                data-test="view-claim-details-button-svg"
                                aria-label="arrow right"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="view-claim-details-button-svg-title">
                                    arrow right
                                </title>
                                <use xlinkHref="#anatomy-arrow-right" />
                            </svg>
                        </a>
                    </div>
                </div>
            </article>,
        (props: { index: number }) =>
            <article
                tabIndex={props.index}
                key={props.index}
                aria-labelledby="ea930407-26d0-499a-a9b1-353b31710a9b"
                data-test="claims-list-card-article"
            >
                <div
                    data-test="claims-list-card"
                    className="claims-list-card__card cont_-fTUNmzJEk8hzLLW9Reow"
                >
                    <div className="claims-list-card__card-content-wrapper">
                        <div
                            className="claims-list-card__card-header"
                            data-test="claims-list-card-header"
                        >
                            <svg
                                className="svg cont_-wwx2NYr81U9_IJm7yiKR cont_-e6TXteWBj4Og8INecdNQ claims-list-card__card-icon"
                                data-test="claims-card-icon"
                                aria-label="medical"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="claims-card-icon-title">
                                    medical
                                </title>
                                <use xlinkHref="#anatomy-stethoscope" />
                            </svg>
                            <div className="claims-list-card__card-info">
                                <h2
                                    className="cont_-SFHQaE2KJVgFh593fnTV soft-bottom claims-list-card__card-provider"
                                    data-test="claims-card-provider"
                                    id="ea930407-26d0-499a-a9b1-353b31710a9b"
                                >
                                    Shelly Thomas
                                </h2>
                                <time
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1"
                                    data-test="claims-card-date"
                                >
                                    Visited on Jul 7, 2022
                                </time>
                                <p
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1 claims-list-card__card-member"
                                    data-test="claims-card-patient-name"
                                >
                                    For Ziping (Self)
                                </p>
                            </div>
                        </div>
                        <div className="claims-list-card__card-cost">
                            <ul className="claims-list-card__card-list">
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-member-rate-label"
                                    >
                                        Amount billed
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-provider-billed"
                                    >
                                        $448.32
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-plan-paid-label"
                                    >
                                        Your plan paid
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-plan-paid"
                                    >
                                        $201.74
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-total-cost-label"
                                    >
                                        Total amount you may owe
                                    </p>
                                    <div
                                        className="cont_-HFCcfnb1BOHqQqG09HQ5"
                                        data-test="claims-card-total"
                                    >
                                        $22.42
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="claims-list-card__card-actions">
                        <a
                            className="claims-list-card__card-button cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
                            data-test="view-claim-details-button"
                            data-name="View Details"
                            href="https://health.aetna.com/manage/claims/56~3ABHWZHB+22+1159+F+EW4?membershipResourceId=5~264012314%2B18%2B101%2B20220601%2B868404%2BA%2B1"
                            aria-label="View details of visit to Shelly Thomas on Jul 7, 2022 for Ziping (Self)"
                        >
                            View Details
                            <svg
                                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                                data-test="view-claim-details-button-svg"
                                aria-label="arrow right"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="view-claim-details-button-svg-title">
                                    arrow right
                                </title>
                                <use xlinkHref="#anatomy-arrow-right" />
                            </svg>
                        </a>
                    </div>
                </div>
            </article>,
        (props: { index: number }) =>
            <article
                tabIndex={props.index}
                key={props.index}
                aria-labelledby="e1c08e76-012c-4a12-87f6-55930c4fb8d0"
                data-test="claims-list-card-article"
            >
                <div
                    data-test="claims-list-card"
                    className="claims-list-card__card cont_-fTUNmzJEk8hzLLW9Reow"
                >
                    <div className="claims-list-card__card-content-wrapper">
                        <div
                            className="claims-list-card__card-header"
                            data-test="claims-list-card-header"
                        >
                            <svg
                                className="svg cont_-wwx2NYr81U9_IJm7yiKR cont_-e6TXteWBj4Og8INecdNQ claims-list-card__card-icon"
                                data-test="claims-card-icon"
                                aria-label="medical"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="claims-card-icon-title">
                                    medical
                                </title>
                                <use xlinkHref="#anatomy-stethoscope" />
                            </svg>
                            <div className="claims-list-card__card-info">
                                <h2
                                    className="cont_-SFHQaE2KJVgFh593fnTV soft-bottom claims-list-card__card-provider"
                                    data-test="claims-card-provider"
                                    id="e1c08e76-012c-4a12-87f6-55930c4fb8d0"
                                >
                                    Knoelle Park
                                </h2>
                                <time
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1"
                                    data-test="claims-card-date"
                                >
                                    Visited on Jun 28, 2022
                                </time>
                                <p
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1 claims-list-card__card-member"
                                    data-test="claims-card-patient-name"
                                >
                                    For Ziping (Self)
                                </p>
                            </div>
                        </div>
                        <div className="claims-list-card__card-cost">
                            <ul className="claims-list-card__card-list">
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-member-rate-label"
                                    >
                                        Amount billed
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-provider-billed"
                                    >
                                        $427.43
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-plan-paid-label"
                                    >
                                        Your plan paid
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-plan-paid"
                                    >
                                        $276.27
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-total-cost-label"
                                    >
                                        Total amount you may owe
                                    </p>
                                    <div
                                        className="cont_-HFCcfnb1BOHqQqG09HQ5"
                                        data-test="claims-card-total"
                                    >
                                        $30.70
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="claims-list-card__card-actions">
                        <a
                            className="claims-list-card__card-button cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
                            data-test="view-claim-details-button"
                            data-name="View Details"
                            href="https://health.aetna.com/manage/claims/56~2PBHKJJZ+22+417+F+EW4?membershipResourceId=5~264012314%2B18%2B101%2B20220601%2B868404%2BA%2B1"
                            aria-label="View details of visit to Knoelle Park on Jun 28, 2022 for Ziping (Self)"
                        >
                            View Details
                            <svg
                                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                                data-test="view-claim-details-button-svg"
                                aria-label="arrow right"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="view-claim-details-button-svg-title">
                                    arrow right
                                </title>
                                <use xlinkHref="#anatomy-arrow-right" />
                            </svg>
                        </a>
                    </div>
                </div>
            </article>,
        (props: { index: number }) =>
            <article
                tabIndex={props.index}
                key={props.index}
                aria-labelledby="ee37494e-775c-416b-8467-cd73b5bf9de0"
                data-test="claims-list-card-article"
            >
                <div
                    data-test="claims-list-card"
                    className="claims-list-card__card cont_-fTUNmzJEk8hzLLW9Reow"
                >
                    <div className="claims-list-card__card-content-wrapper">
                        <div
                            className="claims-list-card__card-header"
                            data-test="claims-list-card-header"
                        >
                            <svg
                                className="svg cont_-wwx2NYr81U9_IJm7yiKR cont_-e6TXteWBj4Og8INecdNQ claims-list-card__card-icon"
                                data-test="claims-card-icon"
                                aria-label="medical"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="claims-card-icon-title">
                                    medical
                                </title>
                                <use xlinkHref="#anatomy-stethoscope" />
                            </svg>
                            <div className="claims-list-card__card-info">
                                <h2
                                    className="cont_-SFHQaE2KJVgFh593fnTV soft-bottom claims-list-card__card-provider"
                                    data-test="claims-card-provider"
                                    id="ee37494e-775c-416b-8467-cd73b5bf9de0"
                                >
                                    Scott Lisse
                                </h2>
                                <time
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1"
                                    data-test="claims-card-date"
                                >
                                    Visited on Jun 20, 2022
                                </time>
                                <p
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1 claims-list-card__card-member"
                                    data-test="claims-card-patient-name"
                                >
                                    For Ziping (Self)
                                </p>
                            </div>
                        </div>
                        <div className="claims-list-card__card-cost">
                            <ul className="claims-list-card__card-list">
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-member-rate-label"
                                    >
                                        Amount billed
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-provider-billed"
                                    >
                                        $292.06
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-plan-paid-label"
                                    >
                                        Your plan paid
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-plan-paid"
                                    >
                                        $135.65
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-total-cost-label"
                                    >
                                        Total amount you may owe
                                    </p>
                                    <div
                                        className="cont_-HFCcfnb1BOHqQqG09HQ5"
                                        data-test="claims-card-total"
                                    >
                                        $15.07
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="claims-list-card__card-actions">
                        <a
                            className="claims-list-card__card-button cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
                            data-test="view-claim-details-button"
                            data-name="View Details"
                            href="https://health.aetna.com/manage/claims/56~DTWHKN79+22+544+F+EW3?membershipResourceId=5~264012314%2B18%2B101%2B20220601%2B868404%2BA%2B1"
                            aria-label="View details of visit to Scott Lisse on Jun 20, 2022 for Ziping (Self)"
                        >
                            View Details
                            <svg
                                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                                data-test="view-claim-details-button-svg"
                                aria-label="arrow right"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="view-claim-details-button-svg-title">
                                    arrow right
                                </title>
                                <use xlinkHref="#anatomy-arrow-right" />
                            </svg>
                        </a>
                    </div>
                </div>
            </article>,
        (props: { index: number }) =>
            <article
                tabIndex={props.index}
                key={props.index}
                aria-labelledby="030c279f-238b-4460-93c1-ff1f88a96b57"
                data-test="claims-list-card-article"
            >
                <div
                    data-test="claims-list-card"
                    className="claims-list-card__card cont_-fTUNmzJEk8hzLLW9Reow"
                >
                    <div className="claims-list-card__card-content-wrapper">
                        <div
                            className="claims-list-card__card-header"
                            data-test="claims-list-card-header"
                        >
                            <svg
                                className="svg cont_-wwx2NYr81U9_IJm7yiKR cont_-e6TXteWBj4Og8INecdNQ claims-list-card__card-icon"
                                data-test="claims-card-icon"
                                aria-label="medical"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="claims-card-icon-title">
                                    medical
                                </title>
                                <use xlinkHref="#anatomy-stethoscope" />
                            </svg>
                            <div className="claims-list-card__card-info">
                                <div
                                    className="cont_-iuZqIefdAd34RjD667tH push-bottom claims-list-card__status-badge cont_-w04YyaHKDqIYOyjtqDMH"
                                    data-test="claims-card-status"
                                >
                                    <div className="cont_-eguK7HB0LR74TdMPpg24">
                                        <div className="cont_-weYlCTaB7j6x9rkMZoac" />
                                        <div
                                            className="cont_-cdiG3ytzoWd2oXglsgqs"
                                            data-test="status-badge-text"
                                        >
                                            Denied
                                        </div>
                                    </div>
                                </div>
                                <h2
                                    className="cont_-SFHQaE2KJVgFh593fnTV soft-bottom claims-list-card__card-provider"
                                    data-test="claims-card-provider"
                                    id="030c279f-238b-4460-93c1-ff1f88a96b57"
                                >
                                    James Kingsley
                                </h2>
                                <time
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1"
                                    data-test="claims-card-date"
                                >
                                    Visited on Jun 17, 2022
                                </time>
                                <p
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1 claims-list-card__card-member"
                                    data-test="claims-card-patient-name"
                                >
                                    For Ziping (Self)
                                </p>
                            </div>
                        </div>
                        <div className="claims-list-card__card-cost">
                            <ul className="claims-list-card__card-list">
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-member-rate-label"
                                    >
                                        Amount billed
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-provider-billed"
                                    >
                                        $406.38
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-plan-paid-label"
                                    >
                                        Your plan paid
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-plan-paid"
                                    >
                                        $0.00
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-total-cost-label"
                                    >
                                        Total amount you may owe
                                    </p>
                                    <div
                                        className="cont_-HFCcfnb1BOHqQqG09HQ5"
                                        data-test="claims-card-total"
                                    >
                                        $0.00
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="claims-list-card__card-actions">
                        <a
                            className="claims-list-card__card-button cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
                            data-test="view-claim-details-button"
                            data-name="View Details"
                            href="https://health.aetna.com/manage/claims/56~DFBDJZBV+22+153+F+EW1?membershipResourceId=5~264012314%2B18%2B101%2B20220601%2B868404%2BA%2B1"
                            aria-label="View details of visit to James Kingsley on Jun 17, 2022 for Ziping (Self)"
                        >
                            View Details
                            <svg
                                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                                data-test="view-claim-details-button-svg"
                                aria-label="arrow right"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="view-claim-details-button-svg-title">
                                    arrow right
                                </title>
                                <use xlinkHref="#anatomy-arrow-right" />
                            </svg>
                        </a>
                    </div>
                </div>
            </article>,
        (props: { index: number }) =>
            <article
                tabIndex={props.index}
                key={props.index}
                aria-labelledby="070c1669-90d4-4abc-a794-7a1fe7d47f8c"
                data-test="claims-list-card-article"
            >
                <div
                    data-test="claims-list-card"
                    className="claims-list-card__card cont_-fTUNmzJEk8hzLLW9Reow"
                >
                    <div className="claims-list-card__card-content-wrapper">
                        <div
                            className="claims-list-card__card-header"
                            data-test="claims-list-card-header"
                        >
                            <svg
                                className="svg cont_-wwx2NYr81U9_IJm7yiKR cont_-e6TXteWBj4Og8INecdNQ claims-list-card__card-icon"
                                data-test="claims-card-icon"
                                aria-label="medical"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="claims-card-icon-title">
                                    medical
                                </title>
                                <use xlinkHref="#anatomy-stethoscope" />
                            </svg>
                            <div className="claims-list-card__card-info">
                                <h2
                                    className="cont_-SFHQaE2KJVgFh593fnTV soft-bottom claims-list-card__card-provider"
                                    data-test="claims-card-provider"
                                    id="070c1669-90d4-4abc-a794-7a1fe7d47f8c"
                                >
                                    James Kingsley
                                </h2>
                                <time
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1"
                                    data-test="claims-card-date"
                                >
                                    Visited on Jun 17, 2022
                                </time>
                                <p
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1 claims-list-card__card-member"
                                    data-test="claims-card-patient-name"
                                >
                                    For Ziping (Self)
                                </p>
                            </div>
                        </div>
                        <div className="claims-list-card__card-cost">
                            <ul className="claims-list-card__card-list">
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-member-rate-label"
                                    >
                                        Amount billed
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-provider-billed"
                                    >
                                        $406.38
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-plan-paid-label"
                                    >
                                        Your plan paid
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-plan-paid"
                                    >
                                        $85.58
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-total-cost-label"
                                    >
                                        Total amount you may owe
                                    </p>
                                    <div
                                        className="cont_-HFCcfnb1BOHqQqG09HQ5"
                                        data-test="claims-card-total"
                                    >
                                        $9.51
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="claims-list-card__card-actions">
                        <a
                            className="claims-list-card__card-button cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
                            data-test="view-claim-details-button"
                            data-name="View Details"
                            href="https://health.aetna.com/manage/claims/56~DFBDJZBS+22+151+F+EW1?membershipResourceId=5~264012314%2B18%2B101%2B20220601%2B868404%2BA%2B1"
                            aria-label="View details of visit to James Kingsley on Jun 17, 2022 for Ziping (Self)"
                        >
                            View Details
                            <svg
                                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                                data-test="view-claim-details-button-svg"
                                aria-label="arrow right"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="view-claim-details-button-svg-title">
                                    arrow right
                                </title>
                                <use xlinkHref="#anatomy-arrow-right" />
                            </svg>
                        </a>
                    </div>
                </div>
            </article>,
        (props: { index: number }) =>
            <article
                tabIndex={props.index}
                key={props.index}
                aria-labelledby="833a28ae-7515-459b-b146-b36522b47b9e"
                data-test="claims-list-card-article"
            >
                <div
                    data-test="claims-list-card"
                    className="claims-list-card__card cont_-fTUNmzJEk8hzLLW9Reow"
                >
                    <div className="claims-list-card__card-content-wrapper">
                        <div
                            className="claims-list-card__card-header"
                            data-test="claims-list-card-header"
                        >
                            <svg
                                className="svg cont_-wwx2NYr81U9_IJm7yiKR cont_-e6TXteWBj4Og8INecdNQ claims-list-card__card-icon"
                                data-test="claims-card-icon"
                                aria-label="medical"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="claims-card-icon-title">
                                    medical
                                </title>
                                <use xlinkHref="#anatomy-stethoscope" />
                            </svg>
                            <div className="claims-list-card__card-info">
                                <h2
                                    className="cont_-SFHQaE2KJVgFh593fnTV soft-bottom claims-list-card__card-provider"
                                    data-test="claims-card-provider"
                                    id="833a28ae-7515-459b-b146-b36522b47b9e"
                                >
                                    Shelly Thomas
                                </h2>
                                <time
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1"
                                    data-test="claims-card-date"
                                >
                                    Visited on May 31, 2022
                                </time>
                                <p
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1 claims-list-card__card-member"
                                    data-test="claims-card-patient-name"
                                >
                                    For Ziping (Self)
                                </p>
                            </div>
                        </div>
                        <div className="claims-list-card__card-cost">
                            <ul className="claims-list-card__card-list">
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-member-rate-label"
                                    >
                                        Amount billed
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-provider-billed"
                                    >
                                        $448.32
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-plan-paid-label"
                                    >
                                        Your plan paid
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-plan-paid"
                                    >
                                        $201.74
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-total-cost-label"
                                    >
                                        Total amount you may owe
                                    </p>
                                    <div
                                        className="cont_-HFCcfnb1BOHqQqG09HQ5"
                                        data-test="claims-card-total"
                                    >
                                        $22.42
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="claims-list-card__card-actions">
                        <a
                            className="claims-list-card__card-button cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
                            data-test="view-claim-details-button"
                            data-name="View Details"
                            href="https://health.aetna.com/manage/claims/56~1TWGVKD3+22+4042+F+EW4?membershipResourceId=5~264012314%2B18%2B101%2B20220601%2B868404%2BA%2B1"
                            aria-label="View details of visit to Shelly Thomas on May 31, 2022 for Ziping (Self)"
                        >
                            View Details
                            <svg
                                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                                data-test="view-claim-details-button-svg"
                                aria-label="arrow right"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="view-claim-details-button-svg-title">
                                    arrow right
                                </title>
                                <use xlinkHref="#anatomy-arrow-right" />
                            </svg>
                        </a>
                    </div>
                </div>
            </article>,
        (props: { index: number }) =>
            <article
                tabIndex={props.index}
                key={props.index}
                aria-labelledby="4e9405d0-88c0-4b3e-8e79-4bdab21a387c"
                data-test="claims-list-card-article"
            >
                <div
                    data-test="claims-list-card"
                    className="claims-list-card__card cont_-fTUNmzJEk8hzLLW9Reow"
                >
                    <div className="claims-list-card__card-content-wrapper">
                        <div
                            className="claims-list-card__card-header"
                            data-test="claims-list-card-header"
                        >
                            <svg
                                className="svg cont_-wwx2NYr81U9_IJm7yiKR cont_-e6TXteWBj4Og8INecdNQ claims-list-card__card-icon"
                                data-test="claims-card-icon"
                                aria-label="medical"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="claims-card-icon-title">
                                    medical
                                </title>
                                <use xlinkHref="#anatomy-stethoscope" />
                            </svg>
                            <div className="claims-list-card__card-info">
                                <h2
                                    className="cont_-SFHQaE2KJVgFh593fnTV soft-bottom claims-list-card__card-provider"
                                    data-test="claims-card-provider"
                                    id="4e9405d0-88c0-4b3e-8e79-4bdab21a387c"
                                >
                                    James Kingsley
                                </h2>
                                <time
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1"
                                    data-test="claims-card-date"
                                >
                                    Visited on May 24, 2022
                                </time>
                                <p
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1 claims-list-card__card-member"
                                    data-test="claims-card-patient-name"
                                >
                                    For Ziping (Self)
                                </p>
                            </div>
                        </div>
                        <div className="claims-list-card__card-cost">
                            <ul className="claims-list-card__card-list">
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-member-rate-label"
                                    >
                                        Amount billed
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-provider-billed"
                                    >
                                        $286.53
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-plan-paid-label"
                                    >
                                        Your plan paid
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-plan-paid"
                                    >
                                        $60.30
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-total-cost-label"
                                    >
                                        Total amount you may owe
                                    </p>
                                    <div
                                        className="cont_-HFCcfnb1BOHqQqG09HQ5"
                                        data-test="claims-card-total"
                                    >
                                        $6.70
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="claims-list-card__card-actions">
                        <a
                            className="claims-list-card__card-button cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
                            data-test="view-claim-details-button"
                            data-name="View Details"
                            href="https://health.aetna.com/manage/claims/56~NRTJ2CJZ+22+1692+F+EW2?membershipResourceId=5~264012314%2B18%2B101%2B20220601%2B868404%2BA%2B1"
                            aria-label="View details of visit to James Kingsley on May 24, 2022 for Ziping (Self)"
                        >
                            View Details
                            <svg
                                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                                data-test="view-claim-details-button-svg"
                                aria-label="arrow right"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="view-claim-details-button-svg-title">
                                    arrow right
                                </title>
                                <use xlinkHref="#anatomy-arrow-right" />
                            </svg>
                        </a>
                    </div>
                </div>
            </article>,
        (props: { index: number }) =>
            <article
                tabIndex={props.index}
                key={props.index}
                aria-labelledby="8c259f6a-507a-43cc-9a16-7733f00df33d"
                data-test="claims-list-card-article"
            >
                <div
                    data-test="claims-list-card"
                    className="claims-list-card__card cont_-fTUNmzJEk8hzLLW9Reow"
                >
                    <div className="claims-list-card__card-content-wrapper">
                        <div
                            className="claims-list-card__card-header"
                            data-test="claims-list-card-header"
                        >
                            <svg
                                className="svg cont_-wwx2NYr81U9_IJm7yiKR cont_-e6TXteWBj4Og8INecdNQ claims-list-card__card-icon"
                                data-test="claims-card-icon"
                                aria-label="medical"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="claims-card-icon-title">
                                    medical
                                </title>
                                <use xlinkHref="#anatomy-stethoscope" />
                            </svg>
                            <div className="claims-list-card__card-info">
                                <h2
                                    className="cont_-SFHQaE2KJVgFh593fnTV soft-bottom claims-list-card__card-provider"
                                    data-test="claims-card-provider"
                                    id="8c259f6a-507a-43cc-9a16-7733f00df33d"
                                >
                                    Rebecca Maxwell
                                </h2>
                                <time
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1"
                                    data-test="claims-card-date"
                                >
                                    Visited on May 13, 2022
                                </time>
                                <p
                                    className="cont_-Wgmvua1EJ6pswU_ayqR1 claims-list-card__card-member"
                                    data-test="claims-card-patient-name"
                                >
                                    For Ziping (Self)
                                </p>
                            </div>
                        </div>
                        <div className="claims-list-card__card-cost">
                            <ul className="claims-list-card__card-list">
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-member-rate-label"
                                    >
                                        Amount billed
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-provider-billed"
                                    >
                                        $250.00
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-plan-paid-label"
                                    >
                                        Your plan paid
                                    </p>
                                    <div
                                        className="cont_-xzf4zIOjrXt5rU5Pdx0v"
                                        data-test="claims-card-plan-paid"
                                    >
                                        $155.65
                                    </div>
                                </li>
                                <li>
                                    <p
                                        className="cont_-R3qAMCKZQlpvA8iFDaXj claims-list-card__label"
                                        data-test="claims-card-total-cost-label"
                                    >
                                        Total amount you may owe
                                    </p>
                                    <div
                                        className="cont_-HFCcfnb1BOHqQqG09HQ5"
                                        data-test="claims-card-total"
                                    >
                                        $17.29
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="claims-list-card__card-actions">
                        <a
                            className="claims-list-card__card-button cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
                            data-test="view-claim-details-button"
                            data-name="View Details"
                            href="https://health.aetna.com/manage/claims/56~NRTHWXBL+22+3146+F+EW5?membershipResourceId=5~264012314%2B18%2B101%2B20220601%2B868404%2BA%2B1"
                            aria-label="View details of visit to Rebecca Maxwell on May 13, 2022 for Ziping (Self)"
                        >
                            View Details
                            <svg
                                className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-WW6a0Ul_wZOcN9_J6EPn cont_-S6msaMk2pPmGHFiKKm7F"
                                data-test="view-claim-details-button-svg"
                                aria-label="arrow right"
                                role="img"
                                aria-hidden="true"
                            >
                                <title data-test="view-claim-details-button-svg-title">
                                    arrow right
                                </title>
                                <use xlinkHref="#anatomy-arrow-right" />
                            </svg>
                        </a>
                    </div>
                </div>
            </article>
    ]
